import React from 'react'
import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import CacheSettings from 'app-support/cache/components/CacheSettings'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_CACHE } from 'app-support/permissions/Permissions'
import { cacheRoute } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(cacheRoute)

const CacheContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_CACHE} exact path={cacheRoute} component={CacheSettings} />
  </Switch>
)

export default enhance(CacheContainer)
